import { strings } from "../../resources/strings";

const iosLink = "https://apps.apple.com/us/app/repath/id1443603077";
const androidLink =
  "https://play.google.com/store/apps/details?id=com.ehawk.repath&hl=en-US";

const AccessDenied = () => {
  return (
    <main
      data-theme="repath"
      className="flex h-screen items-center justify-center w-90 bg-primary"
    >
      <dialog id="my_modal_1" className="modal" open>
        <div className="modal-box">
          <img
            src="/DangerIcon.svg"
            alt="Danger Icon"
            className="mx-auto"
            style={{ width: "30%" }}
          />
          <h3 className="font-bold text-3xl" style={{ textAlign: "center" }}>
            {strings.accessDenied}
          </h3>
          <p className="py-4" style={{ textAlign: "center" }}>
            {strings.accessDeniedMessage}
          </p>
          <div
            className="grid grid-cols-2 gap-8"
            style={{ paddingTop: "1rem" }}
          >
            <a href={iosLink}>
              <img
                src="/AppleStore.png"
                alt="Apple Store"
                className="mx-auto"
              />
            </a>
            <a href={androidLink}>
              <img
                src="/GooglePlayStore.png"
                alt="Google Play Store"
                className="mx-auto"
              />
            </a>
          </div>
        </div>
      </dialog>
    </main>
  );
};

export default AccessDenied;
